import { useIntl } from 'react-intl';
import { ReactNode, useMemo } from 'react';
import { format } from 'date-fns';

import { useStyles } from './steps.styles';
import discount from '../../../../../../assets/images/cv/discount.svg';
import store from '../../../../../../assets/images/cv/store.svg';
import { ListUnordered } from '../../../../../common';
import { ListItem } from '../../../../../common/list-unordered';
import { UI_DATE_FORMAT } from '../../../../../../constants';

const Item = ({ icon, item }: { icon: string, item: ReactNode }): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <span className={classes.iconWrapper}>
        <img src={icon} alt="" className={classes.icon} />
      </span>
      <span>{item}</span>
    </>
  );
};

export const Steps = ({ points, date }: { points: number, date: string }): JSX.Element => {
  const intl = useIntl();
  const classes = useStyles();

  const steps = useMemo((): ListItem[] => {
    return [
      {
        id: 'controlVisit.modal.step-1',
        item: <Item item={intl.formatMessage(
          { id: 'controlVisit.modal.step-1' },
          {
            strong: (chunk: ReactNode) => <strong>{chunk}</strong>,
            sup: (chunk: ReactNode) => <sup>{chunk}</sup>,
          },
        )} icon={store} />,
      },
      {
        id: 'controlVisit.modal.step-2',
        item: <Item item={intl.formatMessage(
          { id: 'controlVisit.modal.step-2' },
          {
            strong: (chunk: ReactNode) => <strong>{chunk}</strong>,
            points,
            date: format(new Date(date), UI_DATE_FORMAT),
          },
        )} icon={discount} />,
      },
    ];
  }, [intl, points, date]);

  return (
    <ListUnordered items={steps} listGap="gap-24" itemStyles={classes.item} />
  );
};
